import createUseContext from "constate";
import { useState, useContext } from "react";
import {datasetMode} from '../../Globals/Globals'
import {PREDICITON_MODE, NOPREDICITON_MODE} from '../../Globals/Constants'
import {PREDICTION,ACTUAL,COMBINED,HISTOGRAM_CHART,PREDICTION_HISTOGRAM_DRAW_PAINT,PREDICTION_HISTOGRAM_CANVAS_PENCIL,PREDICTION_HISTOGRAM_CONFIG_BINS, SEEDATA} from './Constants'

function useGraphPredict({ graphType = HISTOGRAM_CHART, initGraphOptions = PREDICTION }) {
  
  const [grapVisOptions, setgrapVisOptions] = useState({

    
     // 'graphOptions':PREDICTION,
     //Study to get only SEEDAYTA
   'graphOptions':initGraphOptions,
    'graphType': graphType,
    'graphDraw':PREDICTION_HISTOGRAM_DRAW_PAINT,
    'grapCanvasOptions':'',
    'graphBrushRefreshOptions':{
      'id':'0',
      'height':0
  },
    'grapCanvasClearToggle':false,
    'graphConfigBins': PREDICTION_HISTOGRAM_CONFIG_BINS
  });

  const [histogramOptions, sethistogramOptions] = useState({
    'graphBins':PREDICTION_HISTOGRAM_CONFIG_BINS,
    'graphID': '',
    'graphClear':'Odelete'
  });

  const [clearOptions, setclearOptions] = useState({
    'graphClear':'Odelete'
  });
 
const [graphFilter, setgraphFilter] = useState({
  'filter':''
})


  return {grapVisOptions,setgrapVisOptions,histogramOptions,sethistogramOptions,
    graphFilter,setgraphFilter,clearOptions,setclearOptions};
}
export const GraphPredictContext = createUseContext(useGraphPredict);
